// extracted by mini-css-extract-plugin
export default {"title":"Customer_title__o4Izq"};